import * as React from "react";
import { Container, Row, Col } from 'reactstrap';
import { Tooltip, Icon, Breadcrumb, Input, Button, AutoComplete, Select, DatePicker, Steps, Tag, Checkbox } from 'antd';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import {convertToRaw} from "draft-js";
import { INFO_POINTS_ARTICLE, INFO_POINTS_EDITION } from "../infoPointsConstants";

const { Option } = Select;
const { TextArea } = Input;

export class HandleArticleRender extends React.Component {

    //campi obbligatorio
    mandatoryField(value, msg = "This field is mandatory") {
        if (value) { // icon error
            return (<Tooltip title={msg}><Icon type="exclamation-circle" style={{ left: '0px', marginLeft: '10px', top: "8px" }} /></Tooltip>)
        }
        else { //icon ok
            return (<Icon type="check-circle" style={{ left: '0px', marginLeft: '10px', top: "8px" }} />)
        }

    }

    validField(from, to, selected) {
        if (selected == "from" && from <= 0)
            return this.mandatoryField(true)

        if (from > to) {
            return this.mandatoryField(true, "The from page cannot be higher than the to page")
        } else {
            return this.mandatoryField(false)
        }
    }

    validFieldBoolean(from, to) {
        if (from > to) {
            return false
        } else {
            return true
        }
    }
    
    render() {

        const { editions, article, articleSaved, activeMagazine, activeEdition, createdEdition, editorState, categories, tagValue, isFromEditionPage } = this.props.data;
        const { editArticle, createArticle, handleEdition, handleInputChange, handleTagChange, handleTagConfirm, handleTagClose, handleClear, onEditorStateChange, handleCategory, handleOnline } = this.props.func;

        let listaEdition = editions.map(edt =>
            <Option key={edt.id}>{edt.number}</Option>
        )

        const listCategory = categories.map(cat => {
            const value = `${cat.name} (${cat.macroCategory.name})`
            return (<Option key={cat.id}>{value}</Option>)
        })

        let tags = []
        if(article.tags) {
            tags = article.tags.map((tag, index) =>
                <Tag key={index} className="mt-2 tag-closable d-inline-block" closable onClose={() => handleTagClose(tag)}>
                    {tag}
                </Tag>
            )
        }

        let activeSaveButton = article.editionId && article.title && article.pageTo && article.pageFrom && article.text && article.categoryId && this.validFieldBoolean(article.pageFrom, article.pageTo) ? true : false;
        let saveButtonSwitch = article.id ? <Button disabled={!activeSaveButton} onClick={editArticle} className="saveButtonHrWizard" icon="save" >Update</Button> : <Button disabled={!activeSaveButton} onClick={createArticle} className="saveButtonHrWizard" icon="save" > Save</Button>

        return (this.props &&
            <Row style={{ width: '100%' }}>
                <Col style={{ minHeight: '50vh' }} sm='12'>
                    <div className="wizardFields wizardContacts" style={{ minHeight: '50vh' }}>
                        <div className="wizardBackground createCat" style={{ height: 'inherit' }}>
                            <div className="modifyHrBox" style={{ width: '100%' }}>
                                <div className={"modifyHr" + articleSaved} style={{ width: '100%' }}>
                                    <Row>
                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_EDITION.MAGAZINE}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Magazine:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Input disabled style={{ width: '100%' }} className="contactText hrNameValidation" placeholder="Article magazine" value={activeMagazine} />
                                            </div>
                                        </Col>
                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_EDITION.EDITION_NUMBER}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Edition number:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex', position: 'relative' }}>
                                                {isFromEditionPage && (
                                                    <Input disabled style={{ width: '100%' }} className="contactText hrNameValidation" value={activeEdition} />
                                                )}
                                                {!isFromEditionPage && (
                                                    <AutoComplete
                                                        disabled={isFromEditionPage}
                                                        dataSource={listaEdition}
                                                        value={activeEdition}
                                                        placeholder="Edition number"
                                                        style={{ width: '100%' }}
                                                        onSelect={handleEdition}
                                                        filterOption={(inputValue, option) =>
                                                            option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                        }
                                                    />
                                                )}

                                                {activeEdition && (<Icon type="close" className="iconClose" onClick={() => handleClear("editionId")} />)}
                                                {this.mandatoryField(!article.editionId)}
                                            </div>
                                        </Col>
                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.THEME}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Topic:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex', position: 'relative' }}>
                                                <AutoComplete
                                                    dataSource={listCategory}
                                                    placeholder={article.category.name ? article.category.name : 'Topic'}
                                                    style={{ width: '100%' }}
                                                    onSelect={handleCategory}
                                                    filterOption={(inputValue, option) =>
                                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                    }/>
                                                {this.mandatoryField(!article.categoryId)}
                                            </div>
                                        </Col>
                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.TAG}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Tag:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex', position: 'relative' }}>
                                                <Input
                                                    type="text"
                                                    className="contactText hrNameValidation"
                                                    style={{ width: '100%' }}
                                                    value={tagValue}
                                                    onChange={handleTagChange}
                                                    onPressEnter={handleTagConfirm} />
                                            </div>
                                            <div>
                                                {tags}
                                            </div>
                                        </Col>
                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.DATE}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Date:</h4>
                                                </Tooltip>
                                            </div>

                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    disabled={true}
                                                    className="endDatePicker fullWidthPicker"
                                                    placeholder="DD/MM/YYYY"
                                                    value={createdEdition}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.PUBLISHED}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Set Published:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Checkbox checked={article.isOnline} onChange={handleOnline}>Show article on front office</Checkbox>
                                            </div>
                                        </Col>
                                        <Col sm="12">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.TITLE}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Title:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Input autoComplete="new-password" style={{ width: '100%' }} name="title" className="contactText hrNameValidation" allowClear={true} placeholder="Article title" value={article.title} onChange={handleInputChange} />
                                                {this.mandatoryField(!article.title)}
                                            </div>
                                        </Col>
                                        <Col sm="12">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.SUBHEAD}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Subhead:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Input autoComplete="new-password" style={{ width: '100%' }} name="occhiello" className="contactText hrNameValidation" allowClear={true} placeholder="Article subhead" value={article.occhiello} onChange={handleInputChange} />
                                            </div>
                                        </Col>
                                        <Col sm="12">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.SUMMARY}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Summary:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Input autoComplete="new-password" style={{ width: '100%' }} name="summary" className="contactText hrNameValidation" allowClear={true} placeholder="Article summary" value={article.summary} onChange={handleInputChange} />
                                            </div>
                                        </Col>
                                        <Col sm="8">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.SIGNATURE}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Signature:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Input autoComplete="new-password" style={{ width: '100%' }} name="signature" className="contactText hrNameValidation" allowClear={true} placeholder="Article signature" value={article.signature} onChange={handleInputChange} />
                                            </div>
                                        </Col>
                                        <Col sm="2">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.PAGE_FROM}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Page from:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Input autoComplete="new-password" min="0" type="number" style={{ width: '100%' }} name="pageFrom" className="contactText hrNameValidation" allowClear={true} placeholder="Article page to" value={article.pageFrom} onChange={handleInputChange} />
                                                {this.validField(article.pageFrom, article.pageTo, "from")}
                                            </div>
                                        </Col>
                                        <Col sm="2">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.PAGE_TO}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Page to:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Input autoComplete="new-password" min="0" type="number" style={{ width: '100%' }} name="pageTo" className="contactText hrNameValidation" allowClear={true} placeholder="Article page from" value={article.pageTo} onChange={handleInputChange} />
                                                {this.validField(article.pageFrom, article.pageTo, "to")}
                                            </div>
                                        </Col>
                                        <Col sm="12">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_ARTICLE.TEXT}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Text:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Editor editorState={editorState} 
                                                        wrapperClassName="w-100"
                                                        toolbarClassName="editorToolbarFMK"
                                                        editorClassName="editorFMK"
                                                        onEditorStateChange={onEditorStateChange}
                                                />
                                                {this.mandatoryField(!article.text)}
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className="buttonHandleEdition">
                                        {saveButtonSwitch}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            
            )

    }
}



// WEBPACK FOOTER //
// ./src/FileMaker/Articles/HandleArticleRender.js